import React from 'react';
import { useEvent } from '../../../../../../data/hooks/eventHooks';
import EmptyScreenContentPlaceholder from '../../../../../elements/EmptyScreenContentPlaceholder/EmptyScreenContentPlaceholder';
import DateMeetings from './DateMeetings';
import { useMeetingsGroupedByDate } from './useMeetingsGroupedByDate';
import { useI18n } from '../../../../../../data/hooks/i18nHooks';

function CommonTabContent(props) {
    const { eventId, meetings } = props,
        event = useEvent(eventId),
        groupedByDate = useMeetingsGroupedByDate(event, meetings),
        i18n = useI18n();

    if (!meetings.length) return <EmptyScreenContentPlaceholder event={event} icon={'/img/event_meetings.png'} title={i18n['label.appointment']} label={i18n['label.tip.no-meeting']} />;

    return groupedByDate.map((g) => <DateMeetings key={g.date} date={g.date} event={event} meetings={g.meetings} />);
}

export default CommonTabContent;
